import { createContext } from 'react';
import { GrossAndTax } from 'ts/dynamic/interfaces/DynamicResponse';

export const DynamicContext = createContext({
  currency: 'usd' as keyof GrossAndTax,
  setCurrency: (_siteConfig: keyof GrossAndTax) => {},
  numberOfPax: 0,
  setNumberOfPax: (_numberOfPax: number) => {},
});
